import { render, staticRenderFns } from "./StaffDelegateDialogWithModal.vue?vue&type=template&id=7d340a08&scoped=true"
import script from "./StaffDelegateDialogWithModal.vue?vue&type=script&lang=js"
export * from "./StaffDelegateDialogWithModal.vue?vue&type=script&lang=js"
import style0 from "./StaffDelegateDialogWithModal.vue?vue&type=style&index=0&id=7d340a08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d340a08",
  null
  
)

export default component.exports